module.exports = __webpack_public_path__ + "img/sucot-2017-thumbnail.767ff1f0.jpg";